// FRAMEWORK
import React, { useContext } from 'react'
import { Link } from 'gatsby'
import CountrySelector from './country-selector'
import AppContext from '../context/app'
import Socials from './socials'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import Offcanvas from 'react-bootstrap/Offcanvas'
import Button from 'react-bootstrap/Button'

const headingStyle = {
    color: '#999',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 700,
    lineHeight: '121%',
    marginBottom: 0,
}

const linkStyle = {
    color: 'white',
    fontFamily: 'Poppins, sans-serif',
    fontSize: 20,
    fontWeight: 700,
    lineHeight: '121%',
    padding: 0,
    textDecoration: 'none',
}

export default function HamburgerOffcanvasNav() {
    const { showNav, setShowNav } = useContext(AppContext)
    const close = () => setShowNav(false)

    return (
        <Navbar.Offcanvas
            placement="end"
            show={showNav}
            onHide={close}
            style={{
                background: `rgba(0, 0, 0, 0.9)`,
                boxShadow: `0px 0px 100px 100px rgba(0,0,0,.9)`,
            }}
        >
            <Offcanvas.Header onHide={close} className='justify-content-between justify-content-md-end align-items-center'>
                <Button variant='' onClick={close}>
                    <img src='/svg/x-close-icon-white.svg' alt='' />
                </Button>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <Nav className='d-flex flex-column' style={{ gap: 40 }}>
                    <div className='d-flex flex-column' style={{ gap: 16 }}>
                        <p style={headingStyle}>
                            PRODUCTS
                        </p>
                        <Nav.Link
                            as={Link}
                            to='/effects'
                            style={linkStyle}
                        >
                            Effects
                        </Nav.Link>
                        <Nav.Link
                            as={Link}
                            to='/expansions'
                            style={linkStyle}
                        >
                            Expansions
                        </Nav.Link>
                        <Nav.Link
                            as={Link}
                            to='/instruments'
                            style={linkStyle}
                        >
                            Instruments
                        </Nav.Link>
                        <Nav.Link
                            as={Link}
                            to='/presets'
                            style={linkStyle}
                        >
                            Presets
                        </Nav.Link>
                        <Nav.Link
                            as={Link}
                            to='/sale'
                            style={linkStyle}
                        >
                            Sale
                        </Nav.Link>
                        <Nav.Link
                            as={Link}
                            to='/collections'
                            style={linkStyle}
                        >
                            Collections
                        </Nav.Link>
                    </div>

                    <div className='d-flex flex-column' style={{ gap: 16 }}>
                        <p style={headingStyle}>
                            MPC Software
                        </p>
                        <a
                            href="https://akaipro.com/mpc-beats"
                            target="_blank"
                            rel='noreferrer'
                            className='d-flex gap-2'
                            style={linkStyle}
                        >
                            MPC Beats
                        </a>
                        <Nav.Link
                            as={Link}
                            to='/mpc2-software'
                            style={linkStyle}
                        >
                            MPC2
                        </Nav.Link>
                         <a
                            href="https://akaipro.com/sounds-and-software/software/standalone/mpc"
                            target="_blank"
                            rel='noreferrer'
                            style={linkStyle}
                        >
                            MPC3
                        </a>
                    </div>

                    <div className='d-flex flex-column' style={{ gap: 16 }}>
                        <p style={headingStyle}>
                            LINKS
                        </p>
                        <a
                            href="https://profile.inmusicbrands.com/"
                            target="_blank"
                            rel='noreferrer'
                            className='d-flex gap-2'
                            style={linkStyle}
                        >
                            My Account
                            <img src='/svg/new-tab-icon-white.svg' alt='' />
                        </a>
                        <a
                            href="https://support.akaipro.com/en/support/home"
                            target="_blank"
                            rel='noreferrer'
                            className='d-flex gap-2'
                            style={linkStyle}
                        >
                            Support
                            <img src='/svg/new-tab-icon-white.svg' alt='' />
                        </a>
                    </div>
                </Nav>

                <CountrySelector style={{ marginTop: 72 }} />
                <Socials keyHelper='offcanvas' variant='primary' style={{ marginTop: 72 }} />
            </Offcanvas.Body>
        </Navbar.Offcanvas>
    )
}
